module.exports = __webpack_public_path__ + "files/414ce44782288fb593556cb3e7c75f86.svg";